// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	if(!(window.ActiveXObject) && "ActiveXObject" in window) {

		//is explorer
		function msieversion() {

			var ua = window.navigator.userAgent;
			var msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}

			return false;
		}

		msieversion();

	} else {
		/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 /*****************************************************/
		var scrollParallax = []
		var scrolled = 0

		// screen height
		var v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") // get it from html
			//get distance in positive value
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				//get distance in negative value (to do the scroll inverse)
				distance = distance * -1
			}
			//Equivalent distance using screen height + element height
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				//Obtain the distance between top screen and document top 0
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				//Distance of bottom page to top of the element
				let relative_distance = scrolled + v_height - topElement
				//transpoling data to move the parallax element relative to the scroll of all the screen
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, // relative to document viewport
				rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
				threshold: 0 // visible amount of item shown in relation to root
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
	}

	$(".form-module-wrapper form").addClass('animate-fade top');
	$(".text-modules-wrapper .text-modules").addClass('animate-fade top');

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

		$("input[name=zip_code]").attr("maxlength", "5");

		weatherApi();

		let screenHeight = $(window).height();
		$('#home .top-img figure, #home .top-img video').css("height", screenHeight);

		$(window).resize(function(){
			screenHeight = $(window).height();
			$('#home .top-img figure, #home .top-img video').css("height", screenHeight);
		});

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

const WEATHER_API_CONF = [
	{
		id_name:"scottsdale",
		target: "#weather_data_1",
		api_key: "0ddd1af8b5b1833cedd6da7a90934cce",
		zip: "85054,us",
		lat: 33.6728827,
		lon: -112.4327946,
		units: "imperial",
		icon_name:"assets/svg/icon-sun.svg",
		getters: {
			// Coordinates by zip/post code
			coordinates: `https://api.openweathermap.org/geo/1.0/zip?zip={zip}&appid={api_key}`,
			// Call current weather data
			current_weather: `https://api.openweathermap.org/data/2.5/weather?lat={lat}&lon={lon}&appid={api_key}`,
		},
		url_icon: "https://openweathermap.org/img/wn/",
	},
	{
		id_name:"north pole",
		target: "#weather_data_2",
		api_key: "0ddd1af8b5b1833cedd6da7a90934cce",
		zip: "99705,us",
		lat: 64.7536824,
		lon: -147.4032388,
		units: "imperial",
		icon_name:"assets/svg/icon-snow.svg",
		getters: {
			// Coordinates by zip/post code
			coordinates: `https://api.openweathermap.org/geo/1.0/zip?zip={zip}&appid={api_key}`,
			// Call current weather data
			current_weather: `https://api.openweathermap.org/data/2.5/weather?lat={lat}&lon={lon}&appid={api_key}`,
		},
		url_icon: "https://openweathermap.org/img/wn/"
	}
	];

const weatherApi = () => {
	WEATHER_API_CONF.forEach(weatheConf=>{
		let weatherBox = document.querySelector(weatheConf.target);
		//If doest find the selector, stop the process.
		if (weatherBox === null) return;
		let urlApi = `${weatheConf.getters.current_weather}&units=${weatheConf.units}`;

		//Replace url with parameters.
		urlApi = urlApi.replace("{lat}", weatheConf.lat);
		urlApi = urlApi.replace("{lon}", weatheConf.lon);
		urlApi = urlApi.replace("{api_key}", weatheConf.api_key);

		getWeatherInfo(urlApi,weatheConf.icon_name,weatheConf.id_name,weatherBox);
	});
	return false;
};

const getWeatherInfo = function(urlApi,url_icon,id_name,weatherBox){
	fetch(urlApi)
	.then((response) => response.json())
	.then((data) => {
		console.log(data);
		//let weatherIcon = data.weather[0].icon;
		let weatherTemp = data.main.temp;
		let location = document.location;

		const htmlFragment = document.createRange().createContextualFragment(`
			<div class="weather-temp">
				<div class="weather-temp-box">
					<div class="weather-temp-icon" style="background-image: url(${location}${url_icon});"></div>
					<div class="weather-temp-label">${weatherTemp} <span>°F</span></div>
				</div>
				<div class="weather-name-city">${id_name}</div>
			</div>
		`);
		weatherBox.appendChild(htmlFragment);
	});
}